import type { ModuleStatus, ModuleVisibility } from '@/shared/schemas';
import type { ModuleFilters } from '@/shared/types';
import { FilterButton, SearchInput } from '@/shared/ui';
import styles from './GalleryControls.module.css';

interface GalleryControlsProps {
  readonly filters: ModuleFilters;
  readonly onStatusChange: (status: ModuleStatus | 'all') => void;
  readonly onVisibilityChange: (visibility: ModuleVisibility | 'all') => void;
  readonly onSearchChange: (search: string) => void;
}

const STATUS_OPTIONS = ['all', 'active', 'alpha', 'archive'] as const;
const VISIBILITY_OPTIONS = ['all', 'public', 'members'] as const;

function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function GalleryControls({
  filters,
  onStatusChange,
  onVisibilityChange,
  onSearchChange,
}: GalleryControlsProps) {
  return (
    <div className={styles.controls}>
      <SearchInput
        id="search"
        label="Search modules"
        placeholder="Search modules..."
        value={filters.search}
        onChange={(e) => onSearchChange(e.target.value)}
      />

      <div className={styles.filterGroup} role="group" aria-label="Filter by status">
        {STATUS_OPTIONS.map((status) => (
          <FilterButton
            key={status}
            isActive={filters.status === status}
            onClick={() => onStatusChange(status)}
          >
            {capitalize(status)}
          </FilterButton>
        ))}
      </div>

      <div className={styles.filterGroup} role="group" aria-label="Filter by visibility">
        {VISIBILITY_OPTIONS.map((visibility) => (
          <FilterButton
            key={visibility}
            isActive={filters.visibility === visibility}
            onClick={() => onVisibilityChange(visibility)}
          >
            {capitalize(visibility)}
          </FilterButton>
        ))}
      </div>
    </div>
  );
}
